import MouseFollower from 'mouse-follower';
import gsap from 'gsap';

MouseFollower.registerGSAP(gsap);

if (window.matchMedia('(pointer: fine)').matches) {
    const cursor = new MouseFollower();
    const skews = document.querySelectorAll('[data-cursor-skew]');

    skews.forEach(element => {
        element.addEventListener('mouseenter', () => {
            cursor.setSkewing(element.dataset.cursorSkew || 3);
        });

        element.addEventListener('mouseleave', () => {
            cursor.removeSkewing();
        });
    });

    const toggles = document.querySelectorAll('[data-cursor-open]');

    toggles.forEach(element => {
        const parent = element.parentElement;
        const openState = element.dataset.cursorOpen;
        let hovered = false;

        const update = () => {
            if (!hovered) return;
            if (parent.classList.contains('is-open')) {
                cursor.addState(openState);
            } else {
                cursor.removeState(openState);
            }
        };

        new MutationObserver(update).observe(parent, { attributes: true, attributeFilter: ['class'] });

        element.addEventListener('mouseenter', () => {
            hovered = true;
            update();
        });

        element.addEventListener('mouseleave', () => {
            hovered = false;
            cursor.removeState(openState);
        });
    });
}
